import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../../apiClient";
import { SSO_URL } from "../../env";
import { GET_APP_WITH_DEFAULT_CONFIG } from "../../apiClient/apiEndpoints";

const DefaultConfigList = ({ applicationId }) => {
  const navigate = useNavigate();
  const [details, setDetails] = useState({});

  const getApplicationDefaultConfiguration = async () => {
    try {
      let data = await apiClient(`${SSO_URL}${GET_APP_WITH_DEFAULT_CONFIG}/${applicationId}`);
      setDetails(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getApplicationDefaultConfiguration();
  }, [applicationId]);

  const handleEdit = (id, appId) => {
    navigate(`/dashboard/application/update/configuration/${appId}/${id}`);
  };

  return (
    <>
      <div className="variable-list ">
        <div className="parent">
          <div>Name</div>
          <div>Type</div>
          <div>Data</div>
          <div>Action</div>
        </div>

        {details?.defaultConfiguration?.map((item, index) => {
          return (
            <div className="child mb-2" key={index}>
              <div className="standardinput">
                <input type="text" disabled={true} value={item.name} className="input form-control mt-0" />
              </div>

              <div className="standardinput">
                <input type="text" disabled={true} value={item.type} className="input form-control mt-0" />
              </div>

              <div className="standardinput">
                <input type="text" disabled={true} value={JSON.stringify(item.data)} className="input form-control mt-0" />
              </div>
              <div className="standardinput">
                <button className="btn btn-primary" onClick={() => handleEdit(item.id, item.application.uuid)}>Edit</button>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default DefaultConfigList;
